<!--
 * 语音输入引导页 — 全屏遮罩，两步引导
-->
<template>
  <div v-if="visible" class="guide-cover" @click.self="noop">
    <!-- ── Step 1 ── -->
    <div v-if="step === 1" class="guide-card guide-card-step1" :style="{ backgroundImage: 'url(' + step1Bg + ')' }">
      <div class="guide-btns">
        <div class="guide-btn guide-btn-secondary" @click="onKnow">我知道了</div>
        <div class="guide-btn guide-btn-primary" @click="onTry">
          立即体验({{ shortcutLabel }})
        </div>
      </div>
    </div>

    <!-- ── Step 2 ── -->
    <div v-if="step === 2" class="guide-card guide-card2">
      <div class="guide-top">
        <img class="guide-top-img1" :src="step2Img1" />
        <img class="guide-top-img2" :src="step2Img2" />
      </div>
      <!-- <div class="guide-title guide-title-step2">
        现在按住<span class="guide-key">{{ shortcutLabel }}</span>键，开始说话
      </div> -->
      <div class="guide-input-area">
        <textarea
          ref="guideInput"
          v-model="demoText"
          class="guide-textarea"
          placeholder="语音识别文字将显示在这里…"
        ></textarea>
      </div>
      <div class="guide-btns">
        <div class="guide-btn guide-btn-secondary2" @click="onShortcutSetting">快捷键设置</div>
        <div class="guide-btn guide-btn-primary2" @click="onDone">体验完成开始使用</div>
      </div>
    </div>
  </div>
</template>

<script>
const GUIDE_PENDING_KEY = "wminput:voice-guide-pending";
const GUIDE_STEP_KEY = "wminput:voice-guide-step";

export default {
  name: "VoiceGuide",
  data() {
    return {
      demoText: "",
      isWin: false,
    };
  },
  created() {
    // 运行时平台检测 — Electron 原生 API，不被 webpack 构建时替换
    try {
      this.isWin = window.require("os").platform() === "win32";
    } catch (_) {
      try {
        this.isWin = /Win/i.test(navigator.platform);
      } catch (__) {
        this.isWin = /Windows/i.test(navigator.userAgent);
      }
    }
  },
  computed: {
    visible() {
      return this.$store.state.guideVisible && this.isMainWindow();
    },
    step() {
      return this.$store.state.guideStep;
    },
    shortcutLabel() {
      return this.$store.state.settingInfo?.voiceShortcut || "Fn";
    },
    step1Bg() {
      return this.isWin
        ? "https://imagessl.lingtuo.cn/A-1ed71af7_20260630134131.png"
        : "https://imagessl.lingtuo.cn/A-1ed71af7_20260623164325.png";
    },
    step2Img1() {
      return this.isWin
        ? "https://imagessl.lingtuo.cn/A-1ed71af7_20260630135956.png"
        : "https://imagessl.lingtuo.cn/A-1ed71af7_20260623171544.png";
    },
    step2Img2() {
      return this.isWin
        ? "https://imagessl.lingtuo.cn/A-1ed71af7_20260630140149.png"
        : "https://imagessl.lingtuo.cn/A-1ed71af7_20260623171602.png";
    },
  },
  watch: {
    step(val) {
      if (val === 2) {
        try {
          sessionStorage.setItem(GUIDE_PENDING_KEY, "1");
          sessionStorage.setItem(GUIDE_STEP_KEY, "2");
        } catch (_) {}
        // 通知主进程进入引导模式（允许本 App 内触发录音）
        this.$nextTick(() => {
          this.focusGuideInput();
          try {
            const { ipcRenderer } = window.require("electron");
            ipcRenderer.send("voice-guide-step2");
            // 监听粘贴文本
            ipcRenderer.on("voice-guide-paste", this.onPaste);
          } catch (_) {}
        });
      }
    },
    visible(val) {
      if (val) {
        // 引导展示时主窗口调为标准尺寸 624×434
        try {
          const { ipcRenderer } = window.require("electron");
          ipcRenderer.send("voice-guide-resize");
        } catch (_) {}
        if (this.step === 2) {
          this.$nextTick(() => this.focusGuideInput());
        }
      } else {
        this.demoText = "";
        try {
          const { ipcRenderer } = window.require("electron");
          ipcRenderer.removeListener("voice-guide-paste", this.onPaste);
        } catch (_) {}
      }
    },
  },
  methods: {
    focusGuideInput() {
      const input = this.$refs.guideInput;
      if (!input) return;
      input.focus();
      const len = (input.value || "").length;
      if (typeof input.setSelectionRange === "function") {
        input.setSelectionRange(len, len);
      }
    },
    // 最后防线：非主窗口强制不渲染引导弹层
    isMainWindow() {
      try {
        // 主进程标记的子窗口（hash 模式下参数在 location.hash 中）
        if (
          window.location.search.includes("_noGuide=1") ||
          window.location.hash.includes("_noGuide=1")
        ) return false;
        // 路由路径排除
        const forbidden = [
          "/authGuide", "/setting", "/autoSend",
          "/huashuEdit", "/huashuImport", "/imageList", "/huashuReview",
        ];
        const routePath = this.$route && this.$route.path;
        if (routePath && forbidden.includes(routePath)) return false;
      } catch (_) {}
      return true;
    },
    noop() {},
    normalizeGuideText(text) {
      if (typeof text !== "string") return "";
      return text
        .replace(/\r\n/g, "\n")
        .replace(/\\r\\n/g, "\n")
        .replace(/\\n/g, "\n");
    },
    onPaste(_event, text) {
      if (typeof text === "string") {
        this.demoText = this.normalizeGuideText(text);
        this.$nextTick(() => this.focusGuideInput());
      }
    },
    onKnow() {
      this.dismiss();
    },
    onTry() {
      try {
        sessionStorage.setItem(GUIDE_PENDING_KEY, "1");
        sessionStorage.setItem(GUIDE_STEP_KEY, "2");
      } catch (_) {}
      this.$store.commit("setGuideStep", 2);
    },
    onDone() {
      this.dismiss();
    },
    onShortcutSetting() {
      try {
        const { ipcRenderer } = window.require("electron");
        ipcRenderer.send("openSetting", "voiceGuide");
        return;
      } catch (_) {}
      // 浏览器环境兜底：Vue Router 导航
      this.$router.push("/setting");
    },
    dismiss() {
      try {
        sessionStorage.removeItem(GUIDE_PENDING_KEY);
        sessionStorage.removeItem(GUIDE_STEP_KEY);
      } catch (_) {}
      try {
        const { ipcRenderer } = window.require("electron");
        ipcRenderer.send("voice-guide-done");
      } catch (_) {}
      this.$store.commit("hideGuide");
    },
  },
};
</script>

<style scoped>
.guide-cover {
  position: fixed;
  inset: 0;
  z-index: 10000;
  background: rgba(0, 0, 0, 0.75);
  display: flex;
  justify-content: center;
  align-items: center;
}

.guide-card {
  width: 520px;
  background: #fff;
  border-radius: 16px;
  padding: 48px 44px 36px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
}

.guide-card2{
  width: 516px;
  height: 322px;
  padding: 0;
}

.guide-card-step1 {
  width: 514px;
  height: 322px;
  padding: 0;
  background: url("https://imagessl.lingtuo.cn/A-1ed71af7_20260623164325.png") center/contain no-repeat;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
}

.guide-title {
  font-size: 28px;
  font-weight: 700;
  color: #1a1a1a;
  text-align: center;
  line-height: 1.4;
  margin-bottom: 12px;
}

.guide-title-step2 {
  font-size: 22px;
  margin-bottom: 28px;
}

.guide-key {
  display: inline-block;
  background: #f0f0f0;
  border: 1px solid #d0d0d0;
  border-radius: 6px;
  padding: 2px 10px;
  font-weight: 600;
  color: #096bff;
  margin: 0 4px;
}

.guide-input-area {
  width: 100%;
  margin-bottom: 28px;
}

.guide-textarea {
  width: 300px;
  height: 100px;
  border: 2px solid #9484FE;
  border-radius: 10px;
  padding: 14px 16px;
  margin: auto;
  display: block;
  font-size: 14px;
  color: #333;
  caret-color: #096bff;
  cursor: text;
  resize: none;
  outline: none;
  background: #fafafa;
  font-family: -apple-system, PingFang SC, sans-serif;
  margin-top: 12px;
}

.guide-textarea:focus {
  border-color: #096bff;
  background: #fff;
}

.guide-btns {
  display: flex;
  gap: 16px;
  width: 100%;
  justify-content: center;
  position: relative;
}

.guide-btn {
  width: 180px;
  height: 45px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  transition: all .15s;
  margin-bottom: 7px;
  padding-bottom: 10px;
}

.guide-btn-secondary {
  color: #000000;
  font-size: 16px;
  background: url("https://imagessl.lingtuo.cn/A-1ed71af7_20260623170030.png") center/contain no-repeat;
}

.guide-btn-primary {
  color: #fff;
  font-size: 16px;
  background: url("https://imagessl.lingtuo.cn/A-1ed71af7_20260623170239.png") center/contain no-repeat;
}

.guide-btn-primary:hover {
  /* background: #0858d4; */
}

.guide-btn-primary2{
  color: #fff;
  background: url("https://imagessl.lingtuo.cn/A-1ed71af7_20260623171956.png") center/contain no-repeat;
}

.guide-btn-secondary2{
  background: none;
  font-size: 14px;
  color: #4A90E2;
  position: absolute;
  left: 0;
}

.guide-top{
  display: flex;
  align-items: center;
}

.guide-top-img1{
  width: 89px;
  height: 61px;
  margin-top: 14px;
  margin-left: 14px;
}

.guide-top-img2{
  width: 260px;
  height: 41px;
  margin-top: 23px;
  margin-left: 25px;
}
</style>
